<div class="loader-div">
  <p-progressSpinner class="loader-position" styleClass="spinner-icon" strokeWidth="4"></p-progressSpinner>
</div>
